import { callApiToServer } from '../callApi';

export async function editCompanyFormQuestion(
  authtoken,
  questions,
  companyId,
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify({
        id : companyId,
        form_question : questions
    });
  
    let endUrl = "v1/auth/edit-company-form-question";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
